import { faWarning } from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import {
  FieldErrorsImpl,
  FieldError,
  Merge,
  RefCallBack,
} from "react-hook-form";

import { Input } from "src/base-components/Input";
import { Tooltip } from "src/design-system/Tooltip";
import { PropertyUI } from "src/schema/schemaMappingUtils";

type FieldNameError = { title: string; description: string };

const fieldNameErrors: Record<string, FieldNameError> = {
  required: {
    title: "No Name Specified",
    description: "Field name cannot be empty.",
  },
  unique: {
    title: "Duplicate Name",
    description: "Field name must be unique.",
  },
  pattern: {
    title: "Invalid Character",
    description: `Field name cannot have " or \\ or . as a character.`,
  },
};

export const SchemaNameInput: React.FC<{
  disabled: boolean;
  isNew: boolean;
  onSelect: () => void;
  value: string;
  onChange: (value: string) => void;
  errorStatus?: Merge<FieldError, FieldErrorsImpl<PropertyUI>>;
}> = ({ errorStatus, disabled, value, onChange, isNew, onSelect }) => {
  const nameError = errorStatus?.fieldName
    ? fieldNameErrors[errorStatus.fieldName.type]
    : null;

  const errored = errorStatus?.fieldName !== undefined;

  const refCallback: RefCallBack = (ref: HTMLInputElement) => {
    if (ref && isNew && document.activeElement === ref) {
      ref.select();
      onSelect();
    }
  };

  return (
    <Tooltip
      body={nameError?.description}
      disabled={nameError === null}
      placement="top"
      title={nameError ? nameError.title : ""}
      asChild
    >
      <div className="w-full">
        <Input
          ref={refCallback}
          data-loc="schema-field-name"
          disabled={disabled}
          errored={errored}
          suffixIcon={errored ? { icon: faWarning } : undefined}
          value={value}
          fullWidth
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </Tooltip>
  );
};
